/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
/* eslint-disable */

/**
* このファイルは自動生成されています。そのためgit管理には含まれません。手動で編集してもdeploy時反映されません。
*/

/**
 * 法人個人区分
 * @export
 * @enum {number}
 */
export enum BusinessTypeEnum {
    /** 法人 */
    CORPORATION = 1,
    /** 個人事業主 */
    SOLE_PROPRIETORSHIP = 2
}

/**
 * 法人個人区分 の Union 型
 * @export
 * @typedef BusinessType
 */
export type BusinessType =
  typeof BusinessTypeEnum[keyof typeof BusinessTypeEnum];

/**
 * 法人個人区分 のラベルマップ
 * @export
 */
export const BusinessTypeLabels = {
    /**
     * 数値キー: BusinessTypeEnum.CORPORATION
     * 名前キー:  CORPORATION
     */
    [BusinessTypeEnum.CORPORATION]: '法人',
    CORPORATION:                             '法人',
    /**
     * 数値キー: BusinessTypeEnum.SOLE_PROPRIETORSHIP
     * 名前キー:  SOLE_PROPRIETORSHIP
     */
    [BusinessTypeEnum.SOLE_PROPRIETORSHIP]: '個人事業主',
    SOLE_PROPRIETORSHIP:                             '個人事業主',
} as const;

/**
 * 法人個人区分 のラベル Union 型
 * @export
 * @typedef BusinessTypeLabel
 */
export type BusinessTypeLabel =
  typeof BusinessTypeLabels[keyof typeof BusinessTypeLabels];

/**
 * 法人個人区分 のラベル取得関数
 * @export
 * @param { BusinessType } value - 列挙体の値
 * @returns { BusinessTypeLabel } ラベル文字列
 */
export function getBusinessTypeLabel(
  value: BusinessType
): BusinessTypeLabel {
  return BusinessTypeLabels[value];
}

/**
 * 法人個人区分 のラベル配列を取得する関数
 * @export
 * @param { BusinessType[] } values - 列挙体の値配列
 * @returns { BusinessTypeLabel[] } ラベル文字列配列
 */
export function getBusinessTypeLabels(values: BusinessType[]): BusinessTypeLabel[] {
  return values.map((value) => getBusinessTypeLabel(value));
}

/**
 * 法人個人区分 のラベル配列
 * @export
 */
export const BusinessTypeLabelList = [
  '法人','個人事業主',
] as const;

